import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseInputComponent } from "../base-input/base-input.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { ReactiveFormsModule } from "@angular/forms";
import { FilterType } from "../../../../../../../api/src/data-source/models/filter.model";
import { MatButtonModule } from "@angular/material/button";
import { NgIf } from "@angular/common";

@Component({
  selector: 'app-date-picker',
  standalone: true,
  imports: [
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    NgIf
  ],
  templateUrl: './date-picker.component.html',
  styleUrl: './date-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatePickerComponent extends BaseInputComponent {
  @Input() dateFormat: string = "MM/DD/YYYY";
  @Input() showClearButton: boolean = true;

  protected readonly FilterType = FilterType;
}
